import propTypes from "prop-types";
import React, { useMemo } from "react";
import {
	transformCiclo,
	transformEstadoToText,
	transformEstadoToType,
	transformTipo
} from "../utils/kardexTransform";
import Badge from "./Badge";
import "./KardexTable.css";
import Text from "./Text";

const KardexTable = (props) => {
	const { kardex } = props;
	return (
		<table className="KardexTable">
			<thead className="KardexTable-head">
				<tr>
					<th>
						<Text type="paragraph" weight={700}>
							Materia
						</Text>
					</th>
					<th>
						<Text type="paragraph" weight={700} align="center">
							Tipo
						</Text>
					</th>
					<th>
						<Text type="paragraph" weight={700} align="center">
							Créditos
						</Text>
					</th>
					<th>
						<Text type="paragraph" weight={700} align="center">
							Estado
						</Text>
					</th>
					<th>
						<Text type="paragraph" weight={700} align="right">
							Ciclo
						</Text>
					</th>
				</tr>
			</thead>
			<tbody className="KardexTable-body">
				{kardex.map((kdxObj) => (
					<KardexTableRow {...kdxObj} key={kdxObj.clave} />
				))}
			</tbody>
		</table>
	);
};

const KardexTableRow = (props) => {
	const { clave, nombre: materia, tipo, creditos, estado, ciclo } = props;

	const cicloMateria = useMemo(() => transformCiclo(ciclo), [ciclo]);

	const textEstadoMateria = useMemo(() => transformEstadoToText(estado), [
		estado
	]);

	const estadoMateria = useMemo(() => transformEstadoToType(estado), [estado]);

	const tipoMateria = useMemo(() => transformTipo(tipo), [tipo]);

	return (
		<tr>
			<td className="KardexTable-data KardexTable-dataMateria">
				<Text type="paragraph" weight={600}>
					{materia}
				</Text>
				<Text
					type="paragraph"
					style={{
						color: "var(--gray-8)"
					}}>
					{String(clave).padStart(4, "0")}
				</Text>
			</td>
			<td className="KardexTable-data KardexTable-dataTipo">
				<Text type="paragraph" align="center">
					{tipoMateria}
				</Text>
			</td>
			<td className="KardexTable-data KardexTable-dataCreditos">
				<Text type="paragraph" align="center">
					{creditos}
				</Text>
			</td>
			<td className="KardexTable-data KardexTable-dataEstado">
				<Badge type={estadoMateria}>
					<Text>{textEstadoMateria}</Text>
				</Badge>
			</td>
			<td className="KardexTable-data KardexTable-dataCiclo">
				<Text type="paragraph" align="right">
					<Text>{cicloMateria}</Text>
				</Text>
			</td>
		</tr>
	);
};

KardexTable.propTypes = {
	kardex: propTypes.arrayOf(
		propTypes.shape({
			clave: propTypes.number.isRequired,
			nombre: propTypes.string.isRequired,
			tipo: propTypes.string.isRequired,
			creditos: propTypes.number.isRequired,
			estado: propTypes.string.isRequired,
			ciclo: propTypes.string.isRequired
		})
	).isRequired
};

KardexTableRow.propTypes = {
	clave: propTypes.number.isRequired,
	nombre: propTypes.string.isRequired,
	tipo: propTypes.string.isRequired,
	creditos: propTypes.number.isRequired,
	estado: propTypes.string.isRequired,
	ciclo: propTypes.string.isRequired
};

export default KardexTable;
